import { capitaliseFirstLetter, uncapitaliseFirstLetter } from 'utils/string'

export interface Filter {
  label: string
  mapValue?: {
    toLabel: (val: string) => string
    fromLabel: (val: string) => string
  }
}

export const SEARCHABLE_FILTERS: Record<string, Filter> = {
  STYLES: {
    label: 'styles',
  },
  SUBJECT: {
    label: 'subject',
  },
  TOPIC: {
    label: 'topic',
  },
  PRICE: {
    label: 'price',
    mapValue: {
      toLabel: (value: string) => capitaliseFirstLetter(value),
      fromLabel: (value: string) => uncapitaliseFirstLetter(value),
    },
  },
  THEME: {
    label: 'themes',
  },
  FEATURE: {
    label: 'feature',
  },
}
